<script setup lang="ts">
import CButton from '@lib/components/CButton/CButton.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
  disableDone: boolean
}>()

const emit = defineEmits<{
  (e: 'upload'): void
  (e: 'cancel'): void
}>()
</script>

<template>
  <div class="flex justify-between items-center mt-3">
    <CButton @click="emit('cancel')">
      {{ t('canvasUI.common.cancel') }}
    </CButton>
    <CButton :disabled="disableDone" type="primary" @click="emit('upload')">
      {{ t('canvasUI.common.upload') }}
    </CButton>
  </div>
</template>
